
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinchandrapur() {



const cardData = {
  keyword: 'Cab Service in Chandrapur MIDC',
  heading: 'eTravo: Cab Service in Chandrapur MIDC',
  headingDescription: `eTravo offers dependable and efficient cab services in Chandrapur MIDC, perfectly suited to the transportation demands of industries, corporate staff, and business visitors operating in this key industrial region. Whether it's daily employee commuting, executive transfers, or client pickups, our services ensure comfort, punctuality, and professionalism at every level. Our fleet includes GPS-enabled, air-conditioned vehicles driven by skilled, courteous drivers who understand corporate travel standards. eTravo provides flexible rental packages, optimized routes, and 24/7 support to simplify transportation logistics for companies in Chandrapur MIDC. Choose eTravo for a safe, reliable, and seamless cab experience that meets the pace of industrial progress.`,

  top: 'Top Places to visit in Chandrapur with eTravo',
    "topPlaces": [
    {
      "title": "Chandrapur MIDC Industrial Area",
      "description": "Chandrapur's MIDC Industrial Area is a significant hub hosting a variety of industries, including cement manufacturing, thermal power plants, and paper production units. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Chandrapur City Center",
      "description": "The commercial and administrative heart of Chandrapur, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Chandrapur Railway Station",
      "description": "A crucial railway hub connecting Chandrapur with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Chandrapur Logistics Hub",
      "description": "An emerging logistics center enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Rajiv Gandhi College of Engineering, Research and Technology (RCERT)",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "District General Hospital, Chandrapur",
      "description": "A key healthcare facility in the region. eTravo provides dependable cab services for medical professionals, patients, and visitors, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Shri Varasiddhi Shopping Mall",
      "description": "A popular shopping destination in Chandrapur, offering a variety of retail outlets and entertainment options. eTravo facilitates transportation for shoppers and retail employees, enhancing the shopping experience with convenient and safe travel options."
    },
    {
      "title": "Tadoba Tiger King Resort",
      "description": "A renowned hospitality establishment near the Tadoba Andhari Tiger Reserve. eTravo provides transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    },
    {
      "title": "Mount Litera Zee School, Chandrapur",
      "description": "An esteemed educational institution offering quality education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Mogre Hospital, Vivek Nagar",
      "description": "A multi-specialty hospital serving the healthcare needs of Chandrapur residents. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    }
  ],

services: [
  {
    name: 'Chandrapur MIDC Corporate Cab Rentals',
    description: `Tailored corporate cab rental packages designed specifically for businesses operating in Chandrapur MIDC. Our offerings include both short-term and long-term rentals, featuring a fleet of well-maintained vehicles, flexible booking options, and dedicated customer support to ensure smooth business travel and logistics.`
  },
  {
    name: 'Employee Transport Cab Chandrapur MIDC',
    description: `Reliable employee transport services synchronized with factory and office shift schedules in Chandrapur MIDC. Equipped with GPS tracking and managed by a support team, our cabs guarantee safe, punctual, and comfortable daily commutes for your workforce.`
  },
  {
    name: 'Business Cab Services Chandrapur MIDC',
    description: `Flexible and efficient cab services crafted for business executives, managers, and staff traveling within Chandrapur and nearby areas. Our drivers have thorough knowledge of local routes and traffic conditions, ensuring timely and comfortable transportation for meetings, site visits, and client engagements.`
  },
  {
    name: 'Corporate Staff Cabs Chandrapur MIDC',
    description: `Group transportation solutions for corporate teams featuring multi-route planning and GPS-enabled tracking. This service enhances employee safety, reduces travel costs, and minimizes traffic congestion by coordinating  pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Chandrapur MIDC',
    description: `Dedicated to consistent service quality, our corporate cabs are regularly maintained and driven by professional chauffeurs. We prioritize punctuality, courteous service, and proactive communication tailored to the specific needs of corporate clients in Chandrapur MIDC.`
  },
  {
    name: 'AC Corporate Cabs Chandrapur MIDC',
    description: `Comfort-focused air-conditioned cab services to provide a cool and relaxing travel experience throughout the year. Ideal for daily employee commutes as well as executive rides, ensuring comfort even during Chandrapur’s warmer months.`
  },
  {
    name: 'Staff Pickup and Drop Cab Chandrapur MIDC',
    description: `Comprehensive staff transport with flexible scheduling to accommodate multiple shifts, including night duties. Our 24/7 service availability and experienced drivers ensure your workforce travels safely and punctually at all times.`
  },
  {
    name: 'Affordable Business Cab Rentals Chandrapur MIDC',
    description: `Cost-effective cab rental solutions for startups, SMEs, and large corporations. Transparent pricing models and scalable plans help businesses optimize transportation budgets while maintaining high standards of reliability and service.`
  },
  {
    name: 'Executive Cab Services Chandrapur MIDC',
    description: `Premium executive cab services featuring luxury vehicles and professional chauffeurs. Perfect for airport transfers, VIP client transportation, and important business meetings, offering a discreet and high-class travel experience.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Chandrapur MIDC',
    description: `Fixed-route monthly rental plans designed to streamline employee transport management and reduce administrative complexity. These plans offer consistent service quality, straightforward billing, and easy coordination with HR and facility management teams.`
  },
  {
    name: 'Industrial Area Employee Transport Chandrapur MIDC',
    description: `Specialized employee transport services for industrial units within Chandrapur MIDC, focusing on safety, punctuality, and adherence to industrial regulations. Our optimized routes and scheduling ensure smooth travel for factory workers across all shifts.`
  },
  {
    name: 'Corporate Client Cabs Chandrapur MIDC',
    description: `Exclusive transport services for corporate clients and visiting business guests, ensuring a professional, comfortable, and timely travel experience. From airport pickups to on-site visits, we help your business create a strong and positive impression.`
  },
  {
    name: 'Business Meeting Cabs Chandrapur MIDC',
    description: `Quick-response cab services for executives and professionals attending urgent or scheduled business meetings within Chandrapur and nearby locations. We provide easy booking, prompt dispatch, and reliable travel to keep your business operations running smoothly.`
  },
  {
    name: 'Chandrapur Industrial Area Cab Hire',
    description: `On-demand cab hire services throughout Chandrapur’s industrial zones for site inspections, logistics support, and corporate errands. Our drivers have excellent knowledge of the industrial areas, ensuring efficient and hassle-free transport.`
  },
  {
    name: 'Corporate Shuttle Cabs Chandrapur MIDC',
    description: `Group shuttle services using minibuses and large vans to transport large teams during shift changes, training sessions, or corporate events. This service enhances operational efficiency, reduces carbon footprint, and guarantees coordinated employee transport.`
  }
],

tableData: [
  ['Chandrapur MIDC Corporate Cab Rentals', 'Employee Transport Cab Chandrapur MIDC'],
  ['Business Cab Services Chandrapur MIDC', 'Corporate Staff Cabs Chandrapur MIDC'],
  ['Reliable Corporate Cab Service Chandrapur MIDC', 'AC Corporate Cabs Chandrapur MIDC'],
  ['Staff Pickup and Drop Cab Chandrapur MIDC', 'Affordable Business Cab Rentals Chandrapur MIDC'],
  ['Executive Cab Services Chandrapur MIDC', 'Monthly Corporate Cab Rentals Chandrapur MIDC'],
  ['Industrial Area Employee Transport Chandrapur MIDC', 'Corporate Client Cabs Chandrapur MIDC'],
  ['Business Meeting Cabs Chandrapur MIDC', 'Chandrapur Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Chandrapur MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Chandrapur MIDC",
    "WhyChoosedescription": "eTravo offers specialized cab services designed for businesses operating in Chandrapur MIDC. Our solutions ensure timely and safe transportation for employees, helping improve operational efficiency and workforce satisfaction."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet includes a variety of well-maintained sedans, SUVs, and multi-utility vehicles, suitable for daily employee commutes, executive travel, and client transportation, ensuring comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Expertise",
    "WhyChoosedescription": "Our professional drivers have extensive knowledge of Chandrapur MIDC’s roads and industrial zones, guaranteeing efficient navigation, punctual pickups, and a professional travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We provide flexible booking options including scheduled rides, on-demand services, and long-term contracts to accommodate the varying shift timings of industrial businesses."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our cabs are equipped with GPS tracking systems, allowing real-time monitoring to enhance passenger safety, ensure accountability, and provide transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We offer clear and comprehensive billing with detailed trip breakdowns, facilitating easy financial management and reimbursement for corporate accounts."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our vehicles are regularly sanitized and maintained, and drivers follow stringent hygiene protocols to ensure a safe and healthy travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client receives a dedicated account manager to streamline bookings, provide quick support, and ensure a smooth cab service experience in Chandrapur MIDC."
  }
]







}

const faqData = [
  [
    {
      question: "Which areas do your Chandrapur MIDC cab services cover?",
      answer: "Our cab services cover the entire Chandrapur MIDC and adjoining industrial zones, ensuring smooth daily commute solutions."
    },
    {
      question: "Do you offer shift-based cab scheduling for employees?",
      answer: "Yes, we provide fully customizable cab scheduling to support various shift timings including night and rotating shifts."
    },
    {
      question: "Can businesses opt for consolidated monthly invoicing?",
      answer: "Absolutely. We offer detailed monthly billing with trip summaries to make accounting and expense tracking easy for corporate clients."
    },
    {
      question: "Are your drivers trained for professional service?",
      answer: "Yes, our drivers are trained in industrial route navigation, safe driving practices, and maintaining corporate etiquette."
    },
    {
      question: "What safety protocols are followed in your cabs?",
      answer: "We ensure passenger safety with real-time GPS tracking, sanitized vehicles, verified drivers, and emergency response support."
    },
    {
      question: "Do corporate clients get account-specific support?",
      answer: "Yes, we assign dedicated account managers and provide priority service support for all corporate transportation needs."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Mahesh Thakre",
    designation: "Plant Supervisor, Chandrapur Cement Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has simplified employee transport for us. The service is reliable, punctual, and professionally managed.”"
  },
  {
    name: "Ms. Jyoti Ingole",
    designation: "HR Officer, Chandrapur Industrial Gases",
    rating: [1, 1, 1, 1, 1],
    text: "“We've had a smooth experience with eTravo. Their support team and drivers are responsive and committed to quality service.”"
  }
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Chandrapur MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-chandrapur-midc.jpg",
  "description": "Reliable corporate cab service in Chandrapur MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-chandrapur-midc"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service in Chandrapur MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Chandrapur MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/87.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinchandrapur;